import React from "react";

// import { default_theme } from "../theme";
import en from "../assets/images/UK.jpg";
import de from "../assets/images/DE.jpg";
import { Box, FormControl, InputLabel, MenuItem, Select } from "@mui/material";
// const LANGUAGES = {
//   en: { name: 'English' },
//   de: { name: 'Deutsch' },
// };

export const flags = [
  {
    id: 1,
    source: en,
    alt: "UK flag",
    lang: "en",
  },
  {
    id: 2,
    source: de,
    alt: "German flag",
    lang: "de",
  },
];

const LanguageSwitcher = ({ lang, setLanguage }) => {
  return (
    <Box style={{ display: "flex" }}>
      {/* {flags.map((flag) => (
        <div
          style={{
            paddingBottom: 1,
            borderBottom: flag.lang === lang && "5px solid #67A425",
            opacity: flag.lang === lang ? 1 : 0.5,
            cursor: "pointer",
          }}
          onClick={() => {
            setLanguage(flag?.lang);
          }}
        >
          <img
            src={flag?.source}
            alt={flag?.alt}
            style={{
              width: "50px",
              height: "25px",
            }}
          />
        </div>
      ))} */}
      <FormControl fullWidth>
        <InputLabel id="demo-simple-select-label"></InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={lang}
          label="Age"
          onChange={(e) => setLanguage(e.target.value)}
        >
          {flags.map((flag, i) => (
            <MenuItem value={flag.lang}>
              <img
                src={flag?.source}
                alt={flag?.alt}
                style={{
                  width: "50px",
                  height: "25px",
                }}
              />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default LanguageSwitcher;
